<template>
  <div v-if="haveUser">
    <div class="alert alert-danger" v-if="userIsSuspended">
      <i class="alert-icon far fa-exclamation-triangle"></i>
      This account is suspended, an invoice is 35 days overdue, please contact Arrow Logistics
    </div>
    <div class="alert alert-warning" v-if="user && hasUnpaidInvoices">
      <i class="alert-icon far fa-exclamation-triangle"></i>
      This account has {{ user.unpaid_invoices_count }} unpaid invoices
    </div>

    <div class="row row-clear-md-6-lg-3">
      <div class="col-md-6 col-lg-3" v-if="user.isCarrier">
        <router-link :to="{ name: 'loads.index', query: { user: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-clipboard-list"></i>
              </div>
              <div class="col-xs-8">
                <h5>Loads</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3" v-if="user.isCarrier">
        <router-link :to="{ name: 'trucks.index', query: { user: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-truck-container" /></i>
              </div>
              <div class="col-xs-8">
                <h5>Trucks</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3" v-if="user.isCarrier">
         <router-link :to="{ name: 'drivers.index', query: { user: user.id } }" class="ibox ibox-account-button">
           <div class="ibox-content">
             <div class="row">
               <div class="col-xs-4">
								<i class="far fa-id-card"></i>
               </div>
               <div class="col-xs-8">
                 <h5>Drivers</h5>
               </div>
             </div>
           </div>
         </router-link>
       </div>
      <div class="col-md-6 col-lg-3">
        <router-link :to="{ name: 'jobs.index', query: { user: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-list" /></i>
              </div>
              <div class="col-xs-8">
                <h5>Jobs</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3">
        <router-link :to="{ name: 'locations.index', query: { user: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-map-signs"></i>
              </div>
              <div class="col-xs-8">
                <h5>Locations</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3">
        <router-link :to="{ name: 'users.account-users', params: { id: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-users"></i>
              </div>
              <div class="col-xs-8">
                <h5>Users</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3" v-if="user.isCarrier">
        <router-link :to="{ name: 'payments.index', query: { user: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-money-check-alt"></i>
              </div>
              <div class="col-xs-8">
                <h5>Payments</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3">
        <router-link :to="{ name: 'users.edit', params: { id: user.id } }" class="ibox ibox-account-button">
          <div class="ibox-content">
            <div class="row">
              <div class="col-xs-4">
								<i class="far fa-fw fa-cog"></i>
              </div>
              <div class="col-xs-8">
                <h5>Settings</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="margin-10" v-if="user.isCarrier"></div>

    <section class="job-overview m-t-lg m-b-lg" v-if="user.isCarrier">
			<h2><i class="far fa-clipboard-list"></i> Loads</h2>

      <div class="ibox">
        <div class="ibox-content">
          <ul class="list-detail list-detail-load-breakdown list-detail-load-breakdown-carrier">
            <load-item v-for="load in loads" :key="load.id" :load="load"></load-item>
          </ul>
          <div class="text-center text-muted" v-show="haveNoLoads">
            <strong>No loads found.</strong>
          </div>
        </div>
        <div class="ibox-footer">
          <router-link :to="{ name: 'loads.index' }">View All Scheduled Loads</router-link>
        </div>
      </div>
    </section>

    <div class="margin-10" v-if="user.isCarrier"></div>

    <section class="job-overview m-t-lg m-b-lg">

      <h2><img src="~assets/img/icon-job.svg" /> Jobs <router-link class="material-plus job-new" :to="{ name: 'jobs.create' }" data-toggle="tooltip" data-placement="left" title="Create New Job">+</router-link></h2>

      <div class="ibox">
        <div class="ibox-content">
          <ul class="list-detail list-detail-job">
            <job-item v-for="job in jobs" :key="job.id" :job="job"></job-item>
          </ul>
          <div class="text-center text-muted" v-show="haveNoJobs">
            <strong>No jobs found.</strong>
          </div>
        </div>
        <div class="ibox-footer">
          <router-link :to="{ name: 'jobs.index'}">View All Jobs</router-link>
        </div>
      </div>

    </section>

    <div class="margin-10"></div>

    <section class="dashboard-section m-t-lg m-b-lg">

			<h2><i class="far fa-file-invoice"></i> Invoices</h2>

      <div class="ibox">
        <div class="ibox-content">
          <ul class="list-detail list-detail-invoice">
            <invoice-item v-for="invoice in invoices" :key="invoice.id" :invoice="invoice"></invoice-item>
            <div class="text-center text-muted" v-show="haveNoInvoices">
              <strong>No invoices found.</strong>
            </div>
          </ul>
        </div>
        <div class="ibox-footer">
          <router-link :to="{ name: 'invoices.index' }">View All Invoices</router-link>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import { RESET_USER } from 'vx/mutations'
import JobItem from './../jobs/JobItem'
import LoadItem from './../loads/LoadItem'
import InvoiceItem from './../invoices/InvoiceItem'

export default {
  components: {
    JobItem,
    LoadItem,
    InvoiceItem
  },

  created () {
    this[RESET_USER]()

    this.getUser(this.$route.params.id)
    this.getLoads({ carrier_id: this.$route.params.id, status: 'all', commodity: 'all', page_size: 3 })
    this.getJobs({ user_id: this.$route.params.id, status: 'all', commodity: 'all', page_size: 8 })
    this.getInvoices({ user_id: this.$route.params.id, status: 'all', page_size: 7 })
  },

  beforeDestroy () {
    this[RESET_USER]()
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('load', ['load', 'loads']),
    ...mapGetters('user', ['user']),
    ...mapGetters('job', { jobs: 'jobsDecorated' }),
    ...mapGetters('invoice', { invoices: 'invoicesDecorated' }),

    /**
     * Determine if we have a user loaded.
     *
     * @return boolean
     */
    haveUser () {
      return this.user.id !== null && this.user.id !== undefined
    },

    /**
     * Determine if user has no loads.
     *
     * @return boolean
     */
    haveNoLoads () {
      return this.loads.length === 0
    },

    /**
     * Determine if user has no jobs.
     *
     * @return boolean
     */
    haveNoJobs () {
      return this.jobs.length === 0
    },

    /**
     * Determine if user has no invoices.
     *
     * @return boolean
     */
    haveNoInvoices () {
      return this.invoices.length === 0
    },

    /**
     * Determine if user has unpaid invoices.
     *
     * @return boolean
     */
    hasUnpaidInvoices () {
      return this.user.unpaid_invoices_count > 0
    },

    /**
     * Determine if user is suspended.
     *
     * @return boolean
     */
    userIsSuspended () {
      return this.user.active !== true
    }
  },

  methods: {
    ...mapActions('user', ['getUser']),
    ...mapActions('job', ['getJobs']),
    ...mapActions('load', ['getLoads']),
    ...mapActions('invoice', ['getInvoices']),
    ...mapMutations('user', [RESET_USER])
  }
}
</script>



// WEBPACK FOOTER //
// AdminOverview.vue?1e7feeb7